import '/home/runner/work/dialog/dialog/docs/demo/draggable.md?watch=parent';
export const toc = new Proxy([], {});
export const frontmatter = new Proxy({"title":"draggable","toc":"menu","filename":"docs/demo/draggable.md","lastUpdated":1785141763000,"nav":{"title":"Demo","path":"/demo"}}, {});

export const demoIndex = {
  ids: ["docs-demo-draggable-demo-draggable"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/home/runner/work/dialog/dialog/docs/demo/draggable.md?type=demo')
};